"use strict";

// Delegated from document, so cards added later (load more, async sections) need no setup.
(function () {
  var hover = window.matchMedia("(hover: hover) and (pointer: fine)");
  var touch = window.matchMedia("(hover: none)");
  var primed = new WeakSet();
  var queued = new Set();
  var frameRequest = 0;
  var previewing = null;

  // Slides after the packshot are built with src/srcset parked in data attributes.
  // Slide 2 goes first on a thin connection; the rest share what is left, so a fast swipe never finds 3 ready before 2.
  function load(img, priority) {
    img.loading = "eager";
    img.fetchPriority = priority;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute("data-src");
    img.removeAttribute("data-srcset");
  }

  function stripOf(card) {
    return card && card.querySelector(".card-media-strip");
  }

  // Fills the server-rendered empty slots from data-slides; hrefs copy slide 1 so a picked variant carries over.
  function build(strip) {
    var urls = strip.dataset.slides.split(" ");
    var first = strip.firstElementChild;
    var sizes = first.querySelector("img").getAttribute("sizes") || "";
    strip.removeAttribute("data-slides");
    strip.querySelectorAll(":scope > span").forEach(function (slot, n) {
      var link = document.createElement("a");
      link.href = first.getAttribute("href");
      link.draggable = false;
      link.tabIndex = -1;
      link.setAttribute("aria-hidden", "true");
      link.innerHTML = '<span class="media-item media-item-force-ratio--square"><img class="media" alt="" draggable="false"></span>';
      var img = link.querySelector("img");
      img.sizes = sizes;
      img.dataset.src = urls[n];
      img.dataset.srcset = srcsetFor(urls[n]);
      slot.replaceWith(link);
    });
  }

  function srcsetFor(url) {
    return url.replace(/width=\d+/, "width=360") + " 360w, " + url + " 620w";
  }

  // Touch: fetch slide 2 into the cache without touching the DOM. iOS treats a tap that changes the page as a hover
  // and wants a second tap for the link; a detached Image changes nothing, and the same srcset and sizes pick the file the slide will ask for.
  var warmed = new WeakSet();
  function warm(strip) {
    if (!strip || warmed.has(strip) || !strip.dataset.slides) return;
    if (touch.matches && strip.closest("swipeable-area[options]")) return;
    warmed.add(strip);
    var url = strip.dataset.slides.split(" ")[0];
    var img = new Image();
    img.sizes = strip.firstElementChild.querySelector("img").getAttribute("sizes") || "";
    img.srcset = srcsetFor(url);
    img.src = url;
  }

  // On mouse hover, fetch slide 2 so the first arrow click lands on a loaded image; the rest wait for a real scroll.
  function prime(strip) {
    if (!strip || primed.has(strip)) return;
    // Phone rails scroll natively and the strip is locked by CSS, so its photos are never reachable.
    if (touch.matches && strip.closest("swipeable-area[options]")) return;
    primed.add(strip);
    if (strip.dataset.slides) build(strip);

    var next = strip.querySelector("img[data-src]");
    if (next) load(next, "high");

    if (hover.matches && strip.children.length > 1) {
      var frame = strip.parentElement;
      ["prev", "next"].forEach(function (dir) {
        frame.insertAdjacentHTML(
          "beforeend",
          '<button type="button" class="swipeable-control--pill card-media-arrow card-media-arrow--' + dir +
            '" data-dir="' + (dir === "prev" ? -1 : 1) + '" tabindex="-1" aria-hidden="true">' +
            '<svg width="13" height="8" viewBox="0 0 13 8"><use href="#icon-arrow-no-space"></use></svg></button>'
        );
      });
      update(strip);
    }
  }

  function update(strip) {
    var width = strip.clientWidth;
    if (!width) return;

    var index = Math.round(strip.scrollLeft / width);
    var frame = strip.parentElement;
    var dots = frame.querySelector(".card-dots");
    if (dots) {
      Array.prototype.forEach.call(dots.children, function (dot, n) {
        dot.classList.toggle("is-active", n === index);
      });
    }
    frame.dataset.at = index === 0 ? "start" : index >= strip.children.length - 1 ? "end" : "";
  }

  function flush() {
    frameRequest = 0;
    queued.forEach(update);
    queued.clear();
  }

  document.addEventListener(
    "scroll",
    function (event) {
      var strip = event.target;
      if (!strip.classList || !strip.classList.contains("card-media-strip")) return;

      prime(strip);
      strip.querySelectorAll("img[data-src]").forEach(function (img) {
        load(img, "low");
      });

      // Scrolling the strip means the shopper wants the photos: the picked variant's packshot steps aside until the next chip hover.
      var card = strip.closest(".product-card");
      if (card && card.querySelector(".card-media-variant")) {
        card.dataset.mediaYield = "";
        hideOverlay(card);
      }

      queued.add(strip);
      if (!frameRequest) frameRequest = requestAnimationFrame(flush);
    },
    { capture: true, passive: true }
  );

  // Touch builds its slides on the first swipe (see warm); only the download starts at first contact.
  document.addEventListener(
    "pointerdown",
    function (event) {
      if (event.pointerType === "mouse" || !event.target.closest) return;
      warm(event.target.closest(".card-media-strip"));
    },
    { capture: true, passive: true }
  );

  function hideOverlay(card) {
    var overlay = card.querySelector(".card-media-variant");
    if (overlay) {
      overlay.classList.remove("is-visible");
      delete overlay.dataset.want;
    }
    var frame = card.querySelector(".card-media-bg");
    if (frame) frame.classList.remove("is-previewing");
  }

  // Remembers the original text so clearPreview can put it back.
  function swap(el, value) {
    if (!el || !value) return;
    if (el.dataset.cardDefaultText === undefined) el.dataset.cardDefaultText = el.textContent;
    el.textContent = value;
  }

  // A variant may have nothing to strike, so this one can also empty and hide.
  function swapCap(el, value) {
    if (!el) return;
    if (el.dataset.cardDefaultText === undefined) {
      el.dataset.cardDefaultText = el.textContent;
      el.dataset.cardDefaultHidden = el.hidden ? "1" : "";
    }
    el.textContent = value || "";
    el.hidden = !value;
  }

  function showPrice(card, chip) {
    swap(card.querySelector(".card-price"), chip.dataset.variantPrice);
    swapCap(card.querySelector(".card-cap"), chip.dataset.variantCompare);
  }

  function decoded(src) {
    var img = new Image();
    img.src = src;
    return img.decode();
  }

  // Packshots are transparent PNGs, so the strip underneath is hidden while the overlay shows.
  function preview(chip) {
    var card = chip.closest(".product-card");
    var frame = card && card.querySelector(".card-media-bg");
    if (!frame) return;

    delete card.dataset.mediaYield;

    var overlay = frame.querySelector(".card-media-variant");
    if (!overlay) {
      overlay = document.createElement("img");
      overlay.className = "card-media-variant";
      overlay.alt = "";
      overlay.setAttribute("aria-hidden", "true");
      frame.appendChild(overlay);
    }
    // The strip only fades once the replacement has decoded; a failed image leaves the packshot.
    var src = chip.dataset.variantSrc;
    var ready = overlay.getAttribute("src") === src ? Promise.resolve() : decoded(src);
    overlay.dataset.want = src;
    ready.then(
      function () {
        if (overlay.dataset.want !== src) return;
        if (overlay.getAttribute("src") !== src) overlay.src = src;
        overlay.classList.add("is-visible");
        frame.classList.add("is-previewing");
      },
      function () {
        if (overlay.dataset.want === src) hideOverlay(card);
      }
    );

    showPrice(card, chip);
  }

  function clearPreview(card) {
    var picked = card.querySelector(".card-options__chip.is-picked[data-variant-src]");
    if (picked && card.dataset.mediaYield === undefined) {
      preview(picked);
      return;
    }

    hideOverlay(card);

    if (picked) {
      showPrice(card, picked);
      return;
    }

    var price = card.querySelector(".card-price");
    if (price && price.dataset.cardDefaultText !== undefined) {
      price.textContent = price.dataset.cardDefaultText;
    }

    var cap = card.querySelector(".card-cap");
    if (cap && cap.dataset.cardDefaultText !== undefined) {
      cap.textContent = cap.dataset.cardDefaultText;
      cap.hidden = cap.dataset.cardDefaultHidden === "1";
    }
  }

  // Picks the variant on the card; its links are retargeted at that variant.
  function pick(chip) {
    var card = chip.closest(".product-card");
    if (!card) return;

    card.querySelectorAll(".card-options__chip").forEach(function (other) {
      other.classList.toggle("is-picked", other === chip);
      other.classList.toggle("radio-active", other === chip);
    });

    var href = chip.getAttribute("href");
    if (href) {
      card
        .querySelectorAll("a.absolute-full, .card-media-strip > a, .product-card__action a")
        .forEach(function (link) {
          link.setAttribute("href", href);
        });
    }

    preview(chip);
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target.closest) return;

    var arrow = target.closest(".card-media-arrow");
    if (arrow) {
      var strip = arrow.parentElement.querySelector(".card-media-strip");
      strip.scrollBy({ left: arrow.dataset.dir * strip.clientWidth, behavior: "smooth" });
      return;
    }

    var chip = target.closest(".card-options__chip[data-variant-src]");
    if (!chip) return;

    // Modified or non-primary clicks are the shopper asking for the link.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    pick(chip);
  });

  // pointerover rather than pointerenter: only the former bubbles to document.
  document.addEventListener(
    "pointerover",
    function (event) {
      var target = event.target;
      if (!target.closest) return;

      var chip = target.closest(".card-options__chip[data-variant-src]");
      if (chip) {
        var owner = chip.closest(".product-card");
        if (previewing && previewing !== owner) clearPreview(previewing);
        preview(chip);
        previewing = owner;
        return;
      }

      var card = target.closest(".product-card");
      if (card && event.pointerType === "mouse") prime(stripOf(card));

      if (previewing) {
        clearPreview(previewing);
        previewing = null;
      }
    },
    { passive: true }
  );
})();
